<template>
  <f7-page no-toolbar no-swipeback name="order-submission" @page:init="onPageInit" class="order-submission">
    <f7-navbar>
      <f7-nav-left>
        <f7-link @click="backWinloserp">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("playmusic_001") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <div class="top">
      <!-- 音乐块 -->
      <div class="statistics">
        <ul class="music">
          <li class="position: relative;text-align: center;">
            <div class="musicPic">
              <img :src="`${orderInfo.ProviderGameExtensionData?orderInfo.ProviderGameExtensionData:''}`"  alt="" class="musiclogo rotating-box" :style="rotationStyle">
             <img src="../../../static/images/yt999/music/bg2.png" alt="" class="bg2" ref="bg2">
            </div>
          </li>
          
          <li class="li-right " style="">
            <p>{{ orderInfo.ProviderGameName }}</p>
            <p></p>
          </li>
          <li style="">
            <div class="audio" style="position: relative;">
              <div class="audio-player">
                <audio class="audio" ref="audio" :src="`${orderInfo.ProviderGameURL}`" @play="handlePlay" @pause="handlePause"  @loadedmetadata="handleLoadedMetadata" controls v-if="orderInfo.ProviderGameURL" >
                  <source src="example.mp3" type="audio/mpeg">
                  <source src="example.ogg" type="audio/ogg">
                </audio>
              </div>
              <div style="width: 100%;height: 70px;position: absolute;top: -10px;"></div>

            </div>
          </li>
        </ul>
      </div>
      <div>
        <div class="copy"  :style="{ background: isPlaying ? '#ccc' : 'var(--f7-button-bg-color)' }">
          <span class="copybutton"  @click="startTask()">{{ $t("playmusic_002") }}</span>
        </div>
      </div>
    </div>

    <div class="dialog dialog-orderConfirm" id="dialog-orderConfirm">
      <div class="dialog-inner" @click="closeDialog('dialog-orderConfirm')">
        <img :src="`../static/images/yt999/lucky_${$f7.params.currLang}.png`" style="width: 100%" alt="" />
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapGetters} from "vuex";
import { getinitorderinfo, confirmorder, getmemberwinloserp, getGameInfoByGameCode } from "../../../axios/api";
import preloader from "../../template/preloader";
import { getCookie,getStore  } from "../../../config/utils";
import VueAudio from 'vue-audio';
export default {
  components: { preloader,VueAudio },
  props: {
  
  },
  data() {
    return {
      currencySymbol: '',
      info: {},
      dateRangeDesc: this.$t("common_0034"),
      winloseParams: {
        // StartDate: 20210101,
        // EndDate: 20210712,
        DateRangeType: 1,
      },
      orderParams: {
        // StartDate: 20210101,
        // EndDate: 20210712,
        TicketNo: this.$f7route.params.Id,
      },
      showWinlose: false,
      orderInfo: {},
      winloseInfo: {},
      totalBetAmount: 0,
      totalBalance: 0,
      totalWinlose: 0,
      totalBetCount: 0,
      dailyOrderCountLimit: 0,
      totalStatistics: 0,
      totalDeposit: 0,
      totalWithdrawal: 0,
      totalBonus: 0,
      estimatedCommissionToday: 0,
      link: "",
      timeIng : 0,
      maxTimeIng : 150,
      countDown: 150,
      checkFlag : 'no',
      //歌图转动属性
      rotationDegree : 0 ,
      intervalMusic :null,
      intervalTime : null,
      intervalOk : null,
      isPlaying: false,
      musicFlag: false,

      audioLimitTime: 0,
      stopTimeout: null,
      currentTime : 0,
      isStopTimeoutTriggered : true,
    };
  },
  watch: {},
  computed: {
    rotationStyle() {
      return {
        transform: `rotate(${this.rotationDegree}deg)`
      };
    },
    ...mapGetters(["userInfo"]),
  },
  methods: {
    format(percentage) {
      return percentage === this.dailyOrderCountLimit ? "100%" : `${percentage}%`;
    },

    // handlePlay() {
    //   // console.log('Audio is playing');
    //   this.isPlaying = true;
    //   this.$refs.bg2.style.transform = "rotate(0deg)";
    //   this.$emit('play');
    //   this.onTimeIng();

    // },
    handlePause() {
      // console.log('Audio is paused');
      this.isPlaying = false;
      this.$refs.bg2.style.transform = "rotate(-25deg)";
      this.clearInterval();
      this.$emit('pause');

      if (this.stopTimeout) {
        clearInterval(this.stopTimeout);
        this.stopTimeout = null;
      }
    },
    
    togglePlayPause() {
      const audio = this.$refs.audio;
      if (this.isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
    },
    onPageInit(){
      const self = this;
    },
    onTimeIng(){
      const self = this;
      //歌图转动
      self.intervalMusic = setInterval(() => {
        self.rotationDegree += 5; // 每次点击增加45度
      }, 100);
      if(self.countDown == 0){
        return;
      } 
      self.intervalTime = setInterval(() => {
        self.timeIng++;
        self.countDown--;
        if(self.timeIng == self.maxTimeIng){
          clearInterval(self.intervalTime);
          self.checkFlag = 'yes';
        }
      }, 100);

    },
    
    clearInterval() {
      clearTimeout(this.intervalTime);
      clearInterval(this.intervalMusic);
      // console.log('clear ok');
    },
    startTask(){
      if (this.isPlaying) return;
      this.$refs.audio.play();
      this.handlePause();

    },
    requestConfirmOrder() {
      const self = this;
      const param = { data: JSON.stringify(self.orderParams) };
      self.$f7.params.dialog.closeByBackdropClick = false;
      let promtLoadingGame = self.$f7.dialog
        .create({
          title: "",
          text: this.$t("Order_0017"),
          cssClass: "dialog-preloadorder",
        })
        .open();
      confirmorder(param).then((data) => {
        setTimeout(() => {
          self.$f7.params.dialog.closeByBackdropClick = true;
          promtLoadingGame.close();
          if (data.Code === "NoError") {
            //self.orderInfo = data.Data;
            if (data.Data != null) {
              if (data.Data.ExistsPendingOrder) {
                //Show success
                self.$f7.params.dialog.closeByBackdropClick = false;
                let promtLoadingGame = self.$f7.dialog
                  .create({
                    title: "",
                    text: this.$t("Order_0004"),
                    cssClass: "dialog-preloadorder",
                  })
                  .open();

                //1.5 sec later show have new order
                setTimeout(() => {
                  self.$f7.params.dialog.closeByBackdropClick = true;
                  promtLoadingGame.close();
                  this.orderParams.TicketNo = data.Data.TargetOrderTicketNo;
                  if (data.Data.ShowLuckyPopup) {
                    //show popup then reload ticket info
                    self.$f7.params.dialog.closeByBackdropClick = false;
                    self.$f7.dialog.open("#dialog-orderConfirm", true);
                  } else {
                    // dont show popup then reload ticket info
                    self.$f7.params.dialog.closeByBackdropClick = false;
                    let promtLoadingGame = self.$f7.dialog
                      .create({
                        title: "",
                        text: this.$t("Order_0005"),
                        cssClass: "dialog-preloadorder",
                      })
                      .open();
                    setTimeout(() => {
                      self.$f7.params.dialog.closeByBackdropClick = true;
                      promtLoadingGame.close();
                      this.getTargetOrder(this.orderParams.TicketNo);
                    }, 1500);
                  }
                }, 1500);
              } else {
                self.$f7.params.dialog.closeByBackdropClick = false;
                let promtLoadingGame = self.$f7.dialog
                  .create({
                    title: "",
                    text: this.$t("Order_0004"),
                    cssClass: "dialog-preloadorder",
                  })
                  .open();
                setTimeout(() => {
                  self.$f7.params.dialog.closeByBackdropClick = true;
                  promtLoadingGame.close();
                  // self.successNoshowbtn = false;
                  self.$f7router.navigate("/member-center/order-center/0/");
                }, 1500);
              }
            }
          } else if (data.Code === "BalanceNotEnough") {
            self.$f7.dialog.confirm(
              data.Data,
              this.$t("common_1025"),
              () => {
                self.$f7router.navigate("/member-center/deposit/");
              },
              () => {
                // self.$f7router.back();
              }
            );
          } else {
            self.$f7.dialog.alert(data.Data);
          }
        }, 1800);
      });
    },
    getTargetOrder(targetOrderTicketNo) {
      const self = this;
      const param = { data: JSON.stringify({ TicketNo: targetOrderTicketNo }) };
      getinitorderinfo(param).then((data) => {
        if (data.Code === "NoError") {
          self.orderInfo = data.Data;
        } else {
          //提示
          self.$f7.dialog.alert(data.Data);
        }
      });
    },

    getGameInfoByGameCode() {
      const self = this;
      const param = { data: JSON.stringify({ GameCode: self.$f7route.params.Id }) };
      getGameInfoByGameCode(param).then((data) => {
        if (data.Code === "NoError") {
          self.orderInfo = data.Data;
        } else {
          //提示
          self.$f7.dialog.alert(data.Data);
        }
      });
    },


    selectInitOrderInfo(checkPopup) {
      const self = this;
      const param = { data: JSON.stringify(self.orderParams) };
      getinitorderinfo(param).then((data) => {
        if (data.Code === "NoError") {
          if (checkPopup == true) {
            if (data.Data.ShowLuckyPopup) {
              self.$f7.params.dialog.closeByBackdropClick = false;
              self.$f7.dialog.open("#dialog-orderConfirm", true);
            } else {
              self.orderInfo = data.Data;
            }
          } else {
            self.orderInfo = data.Data;
          }
        } else {
          self.$f7.dialog.alert(data.Data);
        }
      });
    },
    backWinloserp() {
      // this.$f7router.navigate("/member-center/order-center/2/");
      this.$f7router.back();
      
    },
    getDateRangeDesc() {
      const self = this;
      switch (self.winloseParams.DateRangeType.toString()) {
        case "1":
          return this.$t("common_0034");
        case "2":
          return this.$t("common_0036");
        case "3":
          return this.$t("common_0038");

        case "11":
          return this.$t("common_0035");
        case "12":
          return this.$t("common_0037");
        case "13":
          return this.$t("common_0039");

        default:
          return "--";
      }
    },
    selectMemberWinloseRP() {
      // this.$f7router.navigate(`/member-center/order-submission/`);
      const self = this;
      self.showWinlose = false;
      const param = { data: JSON.stringify(self.winloseParams) };
      getmemberwinloserp(param).then((data) => {
        if (data.Code === "NoError") {
          self.winloseInfo = data.Data;
          self.totalBetAmount = self.winloseInfo[0].TotalBetAmount;
          self.totalBalance = self.winloseInfo[0].TotalBalance;
          self.totalWinlose = self.winloseInfo[0].TotalWinlose;
          self.totalBetCount = self.winloseInfo[0].TotalBetCount;
          self.dailyOrderCountLimit = self.winloseInfo[0].DailyOrderCountLimit;

          self.showWinlose = true;
        }
      });
    },
    closeDialog(targetId) {
      //this.$f7.$(".dialog-backdrop").css("background", "transparent");
      this.$f7.params.dialog.closeByBackdropClick = true;
      this.$f7.dialog.close(`#${targetId}`);
      this.$f7.emit("onCloseDialog", targetId);
      //console.log(this.orderParams.TicketNo);
      this.selectMemberWinloseRP();
      this.getTargetOrder(this.orderParams.TicketNo);
    },

    handleLoadedMetadata() {
      const audio = this.$refs.audio;
      if (!audio) return;

      const duration = audio.duration;

      if (duration <= 30) {
        this.audioLimitTime = duration / 2;
      } else {
        this.audioLimitTime = 30;
      }

    },

    handlePlay() {
      if (this.isStopTimeoutTriggered) {
        this.isPlaying = true;
        this.$refs.bg2.style.transform = "rotate(0deg)";
        this.$emit('play');
        this.onTimeIng();
      }

      // 以上老代码

      const audio = this.$refs.audio;
      if (!audio) return;

      // 清除上一次的定时器
      if (this.stopTimeout) {
        clearInterval(this.stopTimeout);
        this.stopTimeout = null;
      }
      
      this.stopTimeout = setInterval(() => {
        this.currentTime = audio.currentTime;
        const timeLeft = this.audioLimitTime - this.currentTime;
        // console.log('zong'+timeLeft)

        if (timeLeft <= 0) {
          // 当前已经超过限制时间
          this.showAudioTip();
          clearInterval(this.stopTimeout)
          audio.pause();
          this.isStopTimeoutTriggered = false;
        }
      },  1000);
      
    },

    showAudioTip() {
      this.$f7.dialog.create({
        title: this.$t('common_0004'),          
        text: this.$t('playmusic_003'),         
        buttons: [
          {
            text: this.$t('common_0001'),        
            onClick: () => {
              // 这里执行确定后的逻辑
              this.$f7router.navigate('/home/');

            },
          },
        ],
        closeByBackdropClick: false, // 不允许点击黑色背景关闭
      }).open();

    },

  },
  created() {
    // this.selectInitOrderInfo(true);
    // this.selectMemberWinloseRP();
    // this.currencySymbol = getStore('currencySymbol');
    this.getGameInfoByGameCode();
  },
  mounted() {

  },
  beforeDestroy() {
    this.clearInterval();   //清理定时器
    clearInterval(this.stopTimeout);
    this.stopTimeout = null;
    
  },
};
</script>
<style lang="less" scoped>
.order-submission {
  --f7-THEME-color: #DA291C;
  color: #464646;
  .top {
    background: #fff;
    // border: 1px solid #bfb6b6;
    // border-radius: 4px;
    //margin: 10px;
    font-size: 14px;
    .stat-item {
      height: 80px;
    }
    .statistics {
      position: relative;
      margin: auto;
      background: #fafafa;
      border-radius: 5px;
      text-align: center;
      border: 1px solid rgba(27, 42, 59, 0.06275);
      margin: 10px;
      .list-type-ico {
        position: absolute;
        top: -13px;
        left: 10px;
      }
      .ico-loc {
        position: absolute;
        top: 10px;
        left: 10px;
      }
      .p-loc {
        margin: 0px 0px 0px 35px;
        font-size: 16px;
        font-weight: 600;
      }
      .p-mobile {
        margin: 5px 0px 0px 35px;
        font-size: 14px;
        color: #050505;
      }
      .p-img {
        width: 70px;
        height: 70px;
        position: absolute;
        top: 5px;
        left: 5px;
        border: 1px solid #e1e1e1;
        border-radius: 4px;
      }
      .p-ticketno {
        width: 96%;
        line-height: 26px;
        display: inline-block;
        margin-top: 0px;
        text-align: left;
        margin-left: 40px;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: -3px;
      }
      .p-ts {
        font-size: 12px;
        width: 90%;
        display: inline-block;
        text-align: left;
        margin-left: 40px;
        margin-top: 5px;
        margin-bottom: 6px;
      }
      .p-item-detail {
        width: calc(100% - 85px);
        margin-left: auto;
        text-align: left;
        .p-item-name {
          font-family: Cairo;
          font-size: 15px;
          font-weight: 600;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .p-item-price {
          margin-top: 8px;
          color: #ff0000;
        }
      }
      li {
        width: 100%;
        display: inline-block;
        margin-top: 10px;
        text-align: left;
        //margin-left: 10px;
        margin-bottom: 10px;
      }
      .li-right {
        text-align: right;
        margin-left: unset;
        //margin-right: 10px;
        .small {
          font-size: 12px;
        }
      }
      .li-center {
        font-weight: bold;
        text-align: center;
        margin-left: unset;
        //margin-right: 10px;
      }
      .li-step {
        margin-left: unset;
        // display:inline-block;
        // margin-bottom: 10px
      }
      .title {
        text-align: center;
        font-size: 18px;
        padding-top: 6px;
        font-weight: bold;
        color: #ad5c09;
      }
      .amount {
        text-align: center;
        font-size: 18px;
        padding-top: 6px;
        font-weight: bold;
        color: #ad5c09;
      }
      .desc {
        border-top: 1px solid #e0dbdb;
        margin-top: 10px;
        .p1 {
          margin: 10px;
          font-weight: bold;
        }
        .p2 {
          margin-left: 10px;
          margin-right: 10px;
          padding-bottom: 10px;
          word-wrap: break-word;
        }
      }
      .success{
        position: absolute;
        right: 20px;
        top: 30px;
      }
    }
    .info {
      width: 90%;
      margin: 10px auto;
      div {
        background: #f1f1f1;
        border-radius: 5px;
        height: 28px;
        line-height: 28px;
        // margin-top: 6px;
        position: relative;
        span:nth-child(1) {
          float: left;
          margin-left: 10px;
        }
        span:nth-child(2) {
          color: #002fb3;
        }
        .refer {
          background: linear-gradient(#decabc, #b19785);
          color: #000;
          height: 26px;
          border-radius: 4px;
          line-height: 28px;
          width: 50px;
          display: inline-block;
          text-align: center;
          position: absolute;
          right: 1px;
          top: 1px;
        }
      }
      .list ul:before {
        background-color: transparent;
      }
      .list ul:after {
        background-color: transparent;
      }
      .list .item-content {
        display: flex;
        justify-content: space-around;
      }
    }
    .line {
      width: 95%;
      margin: auto;
      margin-top: 15px;
      border-top: 1px solid #1b336e;
    }
    .list {
      margin: auto;
    }
    .share {
      width: 90%;
      background: #2d2d2d;
      color: #b1b9ce;
      border-radius: 15px;
      height: 30px;
      line-height: 30px;
      margin: 15px auto;
      position: relative;
      padding-left: 10px;
      .sharedesc {
        width: 96%;
        color: #9cfaff;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .sharebutton {
        width: 80px;
        height: 28px;
        position: absolute;
        right: 1px;
        top: 1px;
        text-align: center;
        display: inline-block;
        color: #000;
        background: linear-gradient(#decabc, #b19785);
        border-radius: 15px;
      }
    }
    .copy {
      width: 95%;
      //background: #2d2d2d;
      background: var(--f7-button-bg-color);
      color: var(--f7-button-text-color);
      border-radius: 7px;
      height: 40px;
      line-height: 30px;
      margin: 25px auto;
      position: relative;
      // padding-left: 10px;
      .sharedesc {
        color: #9cfaff;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
      .copybutton {
        width: 100%;
        height: 36px;
        line-height: 36px;
        text-align: center;
        display: inline-block;
        border-radius: var(--f7-list-inset-border-radius);
        font-size: 16 px;
      }
    }
    .noClick{
      background: #ccc;
    }
  }
  
  .middle {
    border-top: 1px solid #bfbfbf;
    .wallet {
      background: url("../../../static/images/yt999/referrer/icon-up.png") bottom no-repeat, url("../../../static/images/yt999/referrer/highlight.png") bottom #efefef no-repeat;
      background-size: 100%;
      padding-top: 15px;
      width: 50%;
      position: relative;
      > div {
        margin-bottom: 15px !important;
      }
      color: #101010;
      .rebtn {
        background: linear-gradient(#decabc, #b19785);
        border-radius: 4px;
        width: 82%;
        height: 30px;
        line-height: 30px;
        color: #000;
        margin: auto;
      }
    }
    .rightafter::after {
      content: "";
      position: absolute;
      top: 0px;
      right: 0px;
      width: 2px;
      height: 128px;
      background: url("../../../static/images/yt999/navafter.png") bottom no-repeat;
      background-size: 100% 100%;
    }
  }

  .bottom {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    color: #101010;
    .s-title {
      font-size: 12px;
    }
  }
}
//音乐播放器
.music{
  ul li{
    display: block;
  }
  .musicPic{
    height: 150px;
    width: 150px;
    margin: 0 auto;
    position: relative;
    background: url("../../../static/images/yt999/music/bg1.png");
    background-size: 100% 100%;
    display: grid;
    justify-items: center;
    align-items: center;
    img{
      width:80px ;
      width:80px ;
    }
  }

  .bg2{
    height: 80px;
    position: absolute;
    top: 20px;
    right: -50px;
    transform-origin: 100% 0%;
    transform: rotate(-25deg);
    transition: transform 0.5s ease;
  }
  
  .musiclogo{
    border-radius: 40px;
  }
  .rotating-box {
    
    transition: transform 0.5s;
  }
  .li-right{
    margin: 0!important;
    p{
      margin: 0;
      padding-bottom: 5px;
      text-align: center;
    }
    p:nth-child(1){
      font-size: 15px;
      font-weight: bold;
    }
    p:nth-child(2){
      color: rgb(135 130 130);
    }
  }
  .audio-player {
    display: flex;
    align-items: center;
    .audio{
      width: 100%;
      height: 40px;
    }
  }

}
.audio{
  
}
.vue-sound__extern-wrapper{
  display: none;
}
</style>
